import { Injectable } from '@angular/core';

@Injectable()
export class RecipeBoxesCommon {
	
	constructor(
		
	) {

	}

	public commonMethod(){
	}
}



// WEBPACK FOOTER //
// ./src/modules/recipes/pages/recipe-boxes/recipe-boxes.common.ts